module.exports = __webpack_public_path__ + "assets/img/exosome.92a159e4.png";